































import { Component, Vue, Watch } from "vue-property-decorator";
import { Owner } from "@/api/owner/types";
import OwnerSelect from "@/components/ownerSelect/OwnerSelect.vue";
import { RiskReportRequest } from '@/api/report/types';
import * as reportService from '@/services/report';
import { getProducts } from "@/api/products";
import { AvailabilityDTO } from "@/api/products/types";


@Component({
  name: "RiskReport",
  components: {
    OwnerSelect
  }
})

export default class RiskReport extends Vue {

  private cropTypeOption = ["SOY", "CORN"];

  private selectedOwner: Owner | null = null;
  private selectedCropType: string = 'SOY';
  private products: AvailabilityDTO[] = [];
  private loading = false;
  private currentYear: number = (new Date()).getFullYear();

  private async beforeMount() {
    this.loading = true;
    try {
      this.products = (await getProducts()).data;
      this.currentYear = this.availableYears[0];
    } finally {
      this.loading = false;
    }
  }

  @Watch('selectedCropType')
  private onCropTypeChange() {
    // Keep the selected year valid for the newly selected crop.
    this.currentYear = this.availableYears[0];
  }

  private get isAdminUser() {
    return this.$store.getters['user/isAdminUser'];
  }

  private get availableYears(): number[] {
    const years = this.products.find(v => (v.cropType === this.selectedCropType && v.analysisType === 'ANALITICA'))?.years;
    // Fall back to the current year when there is no matching product OR its years list is empty,
    // so availableYears[0] is always a valid number (never undefined) for currentYear/refYear.
    return years && years.length ? years : [(new Date()).getFullYear()];
  }

  private async requestRiskReport() {
    this.loading = true;
    try {
      const request = new RiskReportRequest();
      request.cropType = this.selectedCropType;
      request.refYear = this.currentYear;
      request.ownerId = this.selectedOwner?.uuid ?? null;

      await reportService.downloadRiskReport(request);
    } finally {
      this.loading = false;
    }
  }

}
